const ModuleKeys = {
  TITLE: "title",
  MODULE_NAME_LABEL: "moduleNameLabel",
  MODULE_URL: "moduleUrl"
}

export default ModuleKeys
